export default __webpack_public_path__ + "static/media/searchIcon.6a5a95f5.svg";